import { Component, OnInit } from '@angular/core';
import { ArmccmService } from './armccm.service';
import { Armccm } from './customer.model';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  FormControl,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { CustomValidators } from '../../../core/custom-validators';

@Component({
  selector: 'app-armccm',
  templateUrl: './armccm.component.html',
  styleUrls: ['./armccm.component.css'],
})
export class ArmccmComponent implements OnInit {
  formbuilder: any;
  formGroup: any;
  armccmData: Armccm = new Armccm();
  armccmForm: UntypedFormGroup;
  displayerror: boolean;
  formgroup: UntypedFormGroup;
  months = [];
  years = [];

  constructor(
    private formBuilder: UntypedFormBuilder,
    private service: ArmccmService,
    private router: Router
  ) {}

  public Months = [
    { value: 1, display: 'January' },
    { value: 2, display: 'February' },
    { value: 3, display: 'March' },
    { value: 4, display: 'April' },
    { value: 5, display: 'May' },
    { value: 6, display: 'June' },
    { value: 7, display: 'July' },
    { value: 8, display: 'August' },
    { value: 9, display: 'September' },
    { value: 10, display: 'October' },
    { value: 11, display: 'November' },
    { value: 12, display: 'December' },
  ];

  public Years = [
    { value: '2017', display: '2017' },
    { value: '2018', display: '2018' },
    { value: '2019', display: '2019' },
  ];

  public mask = '(000) 000-0000';

  public reporting = Array<{ value: string; display: string; year: number }>();
  ngOnInit() {
    this.armccmForm = this.formBuilder.group({
      emailAddress: [
        null,
        Validators.compose([
          Validators.required,
          CustomValidators.validEmail,
          CustomValidators.noSpace,
        ]),
      ],
      contactName: [
        null,
        Validators.compose([Validators.required, CustomValidators.noSpace]),
      ],
      companyName: [
        null,
        Validators.compose([Validators.required, CustomValidators.noSpace]),
      ],
      phoneNumber: [
        null,
        Validators.compose([
          Validators.required,
          CustomValidators.PhoneNumberValid,
          CustomValidators.noSpace,
        ]),
      ],
      reportingMonth: [null, Validators.required],
      serviceRevenueRetail: [null, Validators.required],
      uncollectibleRevenues: [null, Validators.required],
      telecommunicationsRetail: [null, Validators.required],
      contributionAmount: [null, Validators.required],
      previousCompanyName: [null],
      explanation: [null],
    });

    this.years = ['2017', '2018', '2019'];

    this.getReportingDropdown();
    this.armccmData.reportingMonth = '';
    this.armccmData.contactName = null;
    this.armccmData.companyName = null;
    this.armccmData.previousCompanyName = null;
    this.armccmData.explanation = null;
    this.armccmData.contributionPercentage = null;
  }

  formatMoney(c) {
    c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  }

  calculate() {
    if (
      +this.armccmData.serviceRevenueRetail >= 0 &&
      +this.armccmData.uncollectibleRevenues >= 0 
    ) {
      // tslint:disable-next-line:max-line-length
      this.armccmData.telecommunicationsRetail = (+this.armccmData.serviceRevenueRetail - +this.armccmData.uncollectibleRevenues).toFixed(2).toString();
      // Client has requested when amount is less than zero this should display zero instead of a negative amount.
      this.armccmData.contributionAmount = (+this.armccmData.telecommunicationsRetail <= 0 ? 0 : (+this.armccmData.telecommunicationsRetail *
        this.armccmData.contributionPercentage).toFixed(2)).toString();
    } else {
      this.armccmData.telecommunicationsRetail = null;
      this.armccmData.contributionAmount = null;
    }
  }


  getReportingDropdown() {
    const now = new Date();
    const CurrentYear = now.getFullYear();
    const month = now.getMonth() + 1;
    if (month === 1) {
      this.assignReportingDropdown(11, CurrentYear - 1);
      this.assignReportingDropdown(12, CurrentYear - 1);
    } else if (month === 2) {
      this.assignReportingDropdown(12, CurrentYear - 1);
      this.assignReportingDropdown(1, CurrentYear);
    } else {
      this.assignReportingDropdown(month - 2, CurrentYear);
      this.assignReportingDropdown(month - 1, CurrentYear);
    }
  }

  assignReportingDropdown(monthNum, year) {
    const month = this.Months.find((x) => x.value === monthNum);
    this.reporting.push({
      value: month.display,
      display: month.display + '-' + year,
      year: year,
    });
  }
  assignReportYear(selected) {
    const selectedYear = this.reporting.find((x) => x.value === selected);
    this.armccmData.reportingYear = selectedYear.year;
    if (this.armccmData.reportingMonth) {
      const month = this.Months.find(
        (x) => x.display === this.armccmData.reportingMonth
      );
      const reportDate = new Date(selectedYear.year, month.value - 1, 1);
      if (reportDate < new Date('2022-05-01')) {
        this.armccmData.contributionPercentage = 0.01435;
      } else if (reportDate >= new Date('2022-05-01')) {
        this.armccmData.contributionPercentage = 0.00;
      }
    }
  }

  print() {
    if (
      !this.armccmForm.valid || this.armccmData.telecommunicationsRetail === null || this.armccmData.contributionAmount === null) {
      Object.keys(this.armccmForm.controls).forEach((key) => {
        this.armccmForm.get(key).markAsTouched();
      });
    } else {
      this.service.SaveArmccm(this.armccmData).subscribe((taxData) => {});
      // }

      // tslint:disable-next-line:max-line-length
      this.armccmData.telecommunicationsRetail = (+this.armccmData
        .telecommunicationsRetail)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
        .toString();
      // tslint:disable-next-line:max-line-length
      this.armccmData.contributionAmount = (+this.armccmData.contributionAmount)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
        .toString();

      const reportUrlPost = this.service.getReportUrl('Armccm');
      const params = {
        'Month': this.armccmData.reportingMonth,
        'Years': this.armccmData.reportingYear,
        'CompanyName': this.armccmData.companyName,
        'ContactName': this.armccmData.contactName,
        'PhoneNumber': this.armccmData.phoneNumber,
        'EmailAddress': this.armccmData.emailAddress,
        'NetValue': this.armccmData.telecommunicationsRetail,
        'ContributionPymt': this.armccmData.contributionAmount,
        'PreviousCompanyName': this.armccmData.previousCompanyName,
        'Explanation': this.armccmData.explanation
      };
      this.service.OpenWindowWithPostRequest(reportUrlPost, params);
    }
  }
  Menu() {
    this.router.navigateByUrl('/forms-home');
  }
}
